import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

export function MergeHeader({ crmType }) {
  function capital(s) {
    if (typeof s !== "string") return null;
    return s.charAt(0).toUpperCase() + s.slice(1).toLocaleLowerCase();
  }

  return (
    <React.Fragment>
      <Icon
        name="exclamation triangle"
        color="yellow"
        style={{ marginRight: "0.6em", paddingTop: "0.2em" }}
        size="large"
      />
      <strong style={{ fontSize: "1rem", marginRight: "1em" }}>
        {`This contact was removed from ${capital(crmType) || "your CRM"}`}
      </strong>
    </React.Fragment>
  );
}

MergeHeader.propTypes = { crmType: PropTypes.string };

MergeHeader.defaultProps = { crmType: undefined };

export default MergeHeader;
